/** The texts Windows and the browser really show; their language is the OS language, not the site's. */
export const WINDOWS_STRINGS = {
  ru: {
    ssTitle: 'Windows защитила ваш компьютер',
    ssBody:
      'Фильтр SmartScreen в Microsoft Defender предотвратил запуск неопознанного приложения, которое может подвергнуть ваш компьютер риску.',
    ssMore: 'Подробнее',
    ssApp: 'Приложение:',
    ssPublisher: 'Издатель:',
    ssUnknown: 'Неизвестный издатель',
    ssRun: 'Выполнить в любом случае',
    ssDontRun: 'Не выполнять',
    brWarning: 'Этот файл обычно не скачивают',
    brKeep: 'Сохранить',
    brDelete: 'Удалить',
  },
  en: {
    ssTitle: 'Windows protected your PC',
    ssBody:
      'Microsoft Defender SmartScreen prevented an unrecognized app from starting. Running this app might put your PC at risk.',
    ssMore: 'More info',
    ssApp: 'App:',
    ssPublisher: 'Publisher:',
    ssUnknown: 'Unknown publisher',
    ssRun: 'Run anyway',
    ssDontRun: "Don't run",
    brWarning: "This file isn't commonly downloaded",
    brKeep: 'Keep',
    brDelete: 'Delete',
  },
} as const

export type WindowsLang = keyof typeof WINDOWS_STRINGS

/** Most PCs in Uzbekistan run Russian Windows; Georgian visitors get the English UI. */
export function windowsUiLang(siteLang: string): WindowsLang {
  return siteLang === 'ru' || siteLang === 'uz' ? 'ru' : 'en'
}

// The real name carries the version (Content-Disposition), e.g. Samly-POS-Setup-1.0.17.exe.
export const INSTALLER_FILE_NAME = 'Samly-POS-Setup-….exe'
